enum ErrorCode {
  USER_HAS_COMPANY = 'SD01',
  USER_IS_COMPANY_OWNER = 'SD04',
}
export default ErrorCode;
